import React from 'react';

function Footer(props) {
  return (
    <>
      <footer
        className="mdn-Footer mdn-Footer--simple mdn-Footer--signature mdn-Footer--bottom"
        role="contentinfo"
      >
        <div className="mdn-Container">
          <div className="mdn-Footer-content">
            <div className="mdn-Footer-disclaimer">
              <p className="mdn-Text mdn-Text--caption mdn-Text--inverse">
                <strong>
                  {props.children ??
                    '© 2020-2021 Claro. Todos os direitos reservados.'}
                </strong>
              </p>
            </div>
            <div className="mdn-Footer-logo">
              <img
                className="mdn-Footer-logo-image"
                src={
                  props.src ??
                  'https://mondrian.claro.com.br/brands/nosvg/assinatura-claro.png'
                }
                alt={props.alt ?? ''}
              />
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
